import { render, staticRenderFns } from "./appversionList.vue?vue&type=template&id=1c350cd8"
import script from "./appversionList.vue?vue&type=script&lang=js"
export * from "./appversionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports